import actionTypes from '../../action-types'

export default (customerProductId, deployedAt) => ({
  type: actionTypes.CUSTOMER_PRODUCTS.DEPLOY,
  payload: {
    customerProductId,
    deployedAt,
  },
})
